@if (showNavigation$ | async) {
  <mat-tab-group (selectedTabChange)="onTabChanged($event)" mat-stretch-tabs="false">
    @for (link of navigation; track link) {
      @if (link.canActivate$ | async) {
        <mat-tab [label]="link.listType | translate" data="thisIsMyData"> </mat-tab>
      }
    }
  </mat-tab-group>
}

<router-outlet></router-outlet>
